<div class="gojs-diagram-container" [style.height.px]="height() ?? 300">
  <div #diagramDiv class="gojs-diagram-div"></div>
</div>
